import { edmCampaign } from '@bingads-webui/edm-campaign';

export const createOrUpdateCampaign = (data) => {
  const campaignEDM = edmCampaign.types.resolve('Model.ShoppingCampaign');
  const campaignResource = new campaignEDM.ResourceIdentifier();
  const createOrUpdateCall = data && data.Id ?
    campaignResource.bulkUpdate.bind(campaignResource) :
    campaignResource.bulkCreate.bind(campaignResource);
  return createOrUpdateCall(data);
};
